/**
 * Data write operation
 */
import {DataWrote, WriteControl, WriteOptions} from "../types";
import {ConnectedDevice, WroteReporter} from "../../device/adapter";
import {CollectionKit} from "../../toolkit";

export class DataWriteOperation {


  constructor(
    /**
     * Write options
     * @private
     */
    private options: WriteOptions,
    /**
     * Write binary
     * @private
     */
    private binary: Uint8Array,
    /**
     * Connected device
     * @private
     */
    private connectedDevice: ConnectedDevice,
  ) {
  }

  public async write(): Promise<WroteReporter> {
    if (!this.options.enableChunkWrite) {
      const reporter = await this.writData(this.binary);
      this.doCallback(reporter, this.binary, 1, 1);
      return reporter;
    }
    const writeData = Array.from(this.binary);
    const parts = CollectionKit.split(writeData, this.options.chunkSize);

    const totalTimes = parts.length;

    let currentTimes = 0;
    for (const part of parts) {
      currentTimes += 1;
      const partBinary = new Uint8Array(part);

      const reporter = await this.writData(partBinary);
      const control = this.doCallback(reporter, partBinary, currentTimes, totalTimes);
      if (control == WriteControl.STOP) {
        reporter.controlExit = true;
        return reporter;
      }

      if (!reporter.ok) {
        return reporter;
      }
    }

    return new WroteReporter(
      true,
      this.binary,
      false,
    );
  }

  private doCallback(
    reporter: WroteReporter,
    binary: Uint8Array,
    currentTimes: number,
    totalTimes: number,
  ): WriteControl {
    const callback = this.options.callback;
    if (!callback) return WriteControl.CONTINUE;

    const dataWrote = new DataWrote(
      binary,
      currentTimes,
      totalTimes,
    );
    if (reporter.ok) {
      return callback.success(dataWrote);
    }
    if (callback.failed) {
      callback.failed(dataWrote, reporter.exception);
    } else {
      console.log('no custom failed callback, full exception: ', reporter.exception);
    }
    return WriteControl.STOP;
  }

  private async writData(binary: Uint8Array): Promise<WroteReporter> {
    try {
      await this.connectedDevice.write(binary);
      return new WroteReporter(
        true,
        binary,
        false,
      );
    } catch (e) {
      return new WroteReporter(
        false,
        binary,
        false,
        e
      );
    }
  }


}
